import React, { useEffect, useState } from "react";
import { Button, Grid, Tabs, Box, Tab, Paper, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import TabPanel from "../../../component/TabPanel";
import { getProjectsList } from "../../../api/resignationChecklist";
import { handleAxiosError } from "../../../config/action-config";
import KTInitiationForm from "../resignationComponents/KT.initiated.form";
import KTChecklistReceivedForm from "../resignationComponents/KT.checklist.received.form";
import CredentialsForm from "../resignationComponents/KT.credential.form";
import { useLocation } from "react-router-dom";
import {
  getLatestStatusDetailsById,
  getResignationStatusById,
} from "../../../api/resignation";

export default function ResignationChecklistDetail() {
  const dispatch = useDispatch();
  const params = useParams();
  const [tabIndex, setTabIndex] = useState(
    // params?.status === "KT_APPROVED" ||
    params?.status === "CREDENTIALS_CHECKLIST_APPROVED" ? 1 : 0
  );
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [projectsLists, setProjectsLists] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [reportingManager, setReportingManager] = useState("");
  const [resgStatus, setResgStatus] = useState("");
  const [statusData, setStatusData] = useState([]);
  const [foundStatus, setFoundStatus] = useState("");
  const [lastStatus, setLastStatus] = useState("");
  const [latestStatus, setLatestStatus] = useState("");
  const [projectAssigned, setProjectAssigned] = useState("");

  const location = useLocation();

  useEffect(() => {
    getProjectData();
  }, []);
  async function getProjectData() {
    try {
      const { data } = await getProjectsList("me", {}, user.token);

      setProjectsLists(data.data);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  useEffect(() => {
    loadResignationStatusData();
  }, []);
  const loadResignationStatusData = () => {
    getResignationStatusById(location.state?.employeeId, user.token)
      .then((res) => {
        let filteredData = res.data.data.filter(
          (currentItem, currentIndex, array) => {
            return (
              array.findIndex(
                (item) => item.status_details === currentItem.status_details
              ) === currentIndex
            );
          }
        );

        const found = filteredData.find(
          (e, i) => e.status_details === params.status
        );

        if (params.status === "KT_APPROVED" && found === undefined) {
          setFoundStatus("KT_APPROVED");
        } else if (found) {
          setFoundStatus(found.status_details);
          let lastObj = filteredData[filteredData.length - 1];
          setLastStatus(lastObj.status_details);
        } else {
          // Handle case when params.status is not "KT_APPROVED" and found is undefined
          console.log("Status not found:", params.status);
        }

        setStatusData(filteredData);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  useEffect(() => {
    if (location.state?.employeeId) {
      getLatestStatus();
    } else {
      navigate("/resignation-request");
    }
  }, []);
  async function getLatestStatus() {
    try {
      const { data } = await getLatestStatusDetailsById(
        location.state?.employeeId,
        user.token
      );
      setLatestStatus(data.data[0].status_details);
      console.log("jjjjioo====", data.data[0].ktflag);
      setProjectAssigned(data.data[0].ktflag);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  return (
    <Box sx={{ borderBottom: 1, width: "100%", borderColor: "divider" }}>
      <Tabs
        value={tabIndex}
        onChange={(e, nv) => {
          if (projectAssigned === 0) {
            setTabIndex(1);
          } else {
            setTabIndex(nv);
          }
        }}
        aria-label="basic tabs example"
      >
        <Tab
          label="kT Checklist"
          id="simple-tab-0"
          aria-controls="simple-tabpanel-0"
          style={{ paddingLeft: 10, paddingRight: 10 }}
        />

        {(params?.status === "CREDENTIALS_CHECKLIST_APPROVED" ||
          params?.status === "KT_APPROVED") && (
          <Tab
            label="Credential Checklist"
            id="simple-tab-2"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        )}
      </Tabs>

      <TabPanel value={tabIndex} index={0}>
        {params?.status === "RESIGNATION ACCEPTED" && (
          <KTInitiationForm
            latestStatus={latestStatus}
            locationemployeeId={location?.state?.employeeId}
          />
        )}

        {params?.status === "KT_ASSIGNED" && (
          <Paper>
            <Typography sx={{ p: 2 }}>
              Kt has been assinged to the emloyee Please Wait For the Employee's
              response for kt.
            </Typography>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  sx={{ m: 1 }}
                  variant="contained"
                  onClick={() => {
                    navigate(-2);
                  }}
                  className="blue-button"
                >
                  CANCEL
                </Button>
              </Box>
            </Grid>
          </Paper>
        )}
        {(params?.status === "KT_SUBMITTED" ||
          params?.status === "KT_APPROVED" ||
          params?.status === "CREDENTIALS_CHECKLIST_APPROVED") && (
          <>
            <KTChecklistReceivedForm
              setEmployeeId={setEmployeeId}
              setReportingManager={setReportingManager}
              setResgStatus={setResgStatus}
              locationemployeeId={location?.state?.employeeId}
              latestStatus={latestStatus}
            />
          </>
        )}
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        {(params?.status === "CREDENTIALS_CHECKLIST_APPROVED" ||
          params?.status === "KT_APPROVED") && (
          <CredentialsForm
            reportingManager={reportingManager}
            foundStatus={foundStatus}
            lastStatus={lastStatus}
            locationemployeeId={location?.state?.employeeId}
            latestStatus={latestStatus}
          />
        )}
      </TabPanel>
    </Box>
  );
}
